import {
    DELETE_TAG_REQUEST,
    deleteTagSuccess,
    deleteTagFailure,
    showSuccessNotification
} from 'Redux/Action';
import { ofType } from 'redux-observable';
import { from } from 'rxjs';
import { mergeMap, catchError } from 'rxjs/operators';
import { TEpic } from "Redux/Config";

export const deleteTagEpic: TEpic = (action$, store$, { TagRepository }) => {
    return action$.pipe(
        ofType(DELETE_TAG_REQUEST),
        mergeMap(action => from(TagRepository.remove( action.payload.id ))
            .pipe(
                mergeMap(() => {
                    return from([
                        showSuccessNotification(`Der Tag wurde erfolgreich gelöscht.`),
                        deleteTagSuccess(action.payload.id),
                    ]);
                }),
                catchError( error => {
                    return from([
                        deleteTagFailure(error),
                    ])
                })
            )
        ),
    );
}
